module.exports = __webpack_public_path__ + "img/idcardf.c0040e46.png";